import React, { useMemo } from 'react';
import { Box, Typography } from 'omaha-design-system';
import { ROTATION_COLORS } from './constants';

interface PeriodHeadersProps {
  gameDuration: number;
}

const PeriodHeaders: React.FC<PeriodHeadersProps> = ({ gameDuration }) => {
  const periods = useMemo(() => {
    const result: { label: string; start: number; end: number }[] = [];
    const numPeriods = Math.ceil(gameDuration / 720);
    for (let i = 0; i < numPeriods; i++) {
      const label = i < 4 ? `Q${i + 1}` : `OT${i - 3}`;
      result.push({ label, start: i * 720, end: Math.min((i + 1) * 720, gameDuration) });
    }
    return result;
  }, [gameDuration]);

  return (
    <Box sx={{ display: 'flex', ml: '340px', mr: '56px', height: 20, mb: 0.5 }}>
      {periods.map((period, idx) => {
        const widthPct = ((period.end - period.start) / gameDuration) * 100;
        return (
          <Typography
            key={idx}
            component="div"
            sx={{
              textAlign: 'center',
              fontSize: '0.65rem',
              color: ROTATION_COLORS.text.muted,
              fontWeight: 500,
              borderLeft: idx > 0 ? '1px solid rgba(58, 63, 75, 0.5)' : 'none',
              width: `${widthPct}%`,
            }}
          >
            {period.label}
          </Typography>
        );
      })}
    </Box>
  );
};

export default PeriodHeaders;
